// Mock data for Emily — an ephemeral (24h) social app.
// NOTE: All data here is MOCKED for the frontend-only preview.

const sizeAvatar = (u) =>
  u.includes('pexels')
    ? `${u}?auto=compress&cs=tinysrgb&fit=crop&w=256&h=256`
    : `${u}?crop=faces&cs=srgb&fit=crop&w=256&h=256&q=80`;

const sizePhoto = (u, w = 900, h = 900) =>
  u.includes('pexels')
    ? (u.includes('?') ? u : `${u}?auto=compress&cs=tinysrgb&w=${w}&h=${h}&fit=crop`)
    : (u.includes('?') ? u : `${u}?crop=entropy&cs=srgb&fit=crop&w=${w}&h=${h}&q=80`);

// ---- Raw image bank ----
const A = {
  emma: sizeAvatar('https://images.unsplash.com/photo-1494790108377-be9c29b29330'),
  sarah: sizeAvatar('https://images.unsplash.com/photo-1580489944761-15a19d654956'),
  david: sizeAvatar('https://images.unsplash.com/photo-1500648767791-00dcc994a43e'),
  emily: sizeAvatar('https://images.pexels.com/photos/37038761/pexels-photo-37038761.jpeg'),
  alex: sizeAvatar('https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d'),
  jessica: sizeAvatar('https://images.unsplash.com/photo-1562337404-3044c84ac061'),
  michael: sizeAvatar('https://images.unsplash.com/photo-1567516364473-233c4b6fcfbe'),
  lisa: sizeAvatar('https://images.pexels.com/photos/30372403/pexels-photo-30372403.jpeg'),
  chris: sizeAvatar('https://images.unsplash.com/photo-1611695434369-a8f5d76ceb7b'),
  anna: sizeAvatar('https://images.unsplash.com/photo-1627130595904-ebeeb6540a93'),
  nina: sizeAvatar('https://images.pexels.com/photos/37148308/pexels-photo-37148308.jpeg'),
  ryan: sizeAvatar('https://images.unsplash.com/photo-1560250097-0b93528c311a'),
};

const P = {
  beach1: sizePhoto('https://images.unsplash.com/photo-1672841828271-54340a6fbcd3', 900, 1100),
  beach2: sizePhoto('https://images.unsplash.com/photo-1770838916964-0ae934bf7632'),
  camera: sizePhoto('https://images.unsplash.com/photo-1542038784456-1ea8e935640e', 900, 1100),
  city: sizePhoto('https://images.unsplash.com/photo-1535498730771-e735b998cd64', 900, 1400),
  dog: sizePhoto('https://images.unsplash.com/photo-1600352774373-7b992e5189de'),
  coffee: sizePhoto('https://images.unsplash.com/photo-1533776992670-a72f4c28235e'),
  sunset: sizePhoto('https://images.unsplash.com/photo-1422493757035-1e5e03968f95', 1200, 700),
  selfie: sizePhoto('https://images.unsplash.com/photo-1758275557354-00904e39c6da', 1200, 800),
  mountain: sizePhoto('https://images.unsplash.com/photo-1504870712357-65ea720d6078', 1200, 800),
  cameraWide: sizePhoto('https://images.unsplash.com/photo-1497316730643-415fac54a2af', 1200, 800),
  coffeeWide: sizePhoto('https://images.unsplash.com/photo-1506372023823-741c83b836fe', 1200, 800),
};

// helper: target timestamp X hours from load (so live countdown reads ~Xh)
export const hoursFromNow = (h) => Date.now() + h * 3600 * 1000 + 30 * 60 * 1000;
export const IMG = { A, P };

export const currentUser = {
  id: 'me',
  name: 'Emma Wilson',
  handle: '@emma',
  avatar: A.emma,
};

export const stories = [
  { id: 's0', name: 'Your Story', avatar: A.emma, isSelf: true, seen: false },
  { id: 's1', name: 'Sarah', avatar: A.sarah, seen: false },
  { id: 's2', name: 'David', avatar: A.david, seen: false },
  { id: 's3', name: 'Emily', avatar: A.emily, seen: false },
  { id: 's4', name: 'Michael', avatar: A.michael, seen: true },
  { id: 's5', name: 'Lisa', avatar: A.lisa, seen: false },
  { id: 's6', name: 'Alex', avatar: A.alex, seen: true },
  { id: 's7', name: 'Anna', avatar: A.anna, seen: false },
];

export const homePosts = [
  {
    id: 'p1', user: 'Sarah Collins', handle: '@sarahc', avatar: A.sarah, verified: true,
    location: 'Maldives', image: P.beach1, caption: 'Paradise found with @mreed and @lisap. Loving these new shades! #travel',
    tagged: ['mreed', 'lisap'], productId: 'sp1',
    likes: 1284, comments: 96, liked: false, expiresAt: hoursFromNow(22),
  },
  {
    id: 'pv', type: 'video', user: 'Michael Reed', handle: '@mreed', avatar: A.michael, verified: true,
    location: 'Travel Diaries', youtubeId: 'LXb3EKWsInQ',
    caption: 'New travel vlog is live! Shot this with @sarahc #vlog #nature',
    tagged: ['sarahc'],
    likes: 3120, comments: 214, liked: false, expiresAt: hoursFromNow(18),
  },
  {
    id: 'p2', user: 'Michael Reed', handle: '@mreed', avatar: A.michael, verified: true,
    location: 'Malibu, CA', image: P.sunset, caption: 'Sunset vibes with the crew.',
    likes: 842, comments: 41, liked: true, expiresAt: hoursFromNow(20),
  },
  {
    id: 'p3', user: 'Lisa Park', handle: '@lisap', avatar: A.lisa, verified: false,
    location: 'Downtown', image: P.selfie, caption: 'Having the best day with these people 💫',
    likes: 2103, comments: 158, liked: false, expiresAt: hoursFromNow(15),
  },
  {
    id: 'p4', user: 'Chris Bennett', handle: '@chrisb', avatar: A.chris, verified: false,
    location: 'Countryside', image: P.dog, caption: 'Golden hour with my best friend 🐾',
    likes: 967, comments: 73, liked: false, expiresAt: hoursFromNow(2),
  },
  {
    id: 'p5', user: 'Anna Torres', handle: '@annat', avatar: A.anna, verified: true,
    location: 'Corner Cafe', image: P.coffee, caption: 'Quick coffee break before the shoot ☕',
    likes: 534, comments: 29, liked: false, expiresAt: hoursFromNow(8),
  },
];

export const moments = [
  { id: 'm1', user: 'Michael', avatar: A.michael, verified: true, caption: 'Sunset vibes!', image: P.sunset, expiresAt: hoursFromNow(22) },
  { id: 'm2', user: 'Lisa', avatar: A.lisa, verified: false, caption: 'Having fun!', image: P.selfie, expiresAt: hoursFromNow(15) },
  { id: 'm3', user: 'Chris', avatar: A.chris, verified: false, caption: 'Hello everyone!', image: P.dog, expiresAt: hoursFromNow(2) },
  { id: 'm4', user: 'Anna', avatar: A.anna, verified: true, caption: 'Quick coffee break!', image: P.coffee, expiresAt: hoursFromNow(8) },
  { id: 'm5', user: 'Sarah', avatar: A.sarah, verified: true, caption: 'Island hopping today 🏝️', image: P.beach2, expiresAt: hoursFromNow(19) },
  { id: 'm6', user: 'Alex', avatar: A.alex, verified: false, caption: 'City never sleeps.', image: P.city, expiresAt: hoursFromNow(11) },
];

export const taggableUsers = [
  { name: 'Sarah Collins', handle: 'sarahc', avatar: A.sarah },
  { name: 'Michael Reed', handle: 'mreed', avatar: A.michael },
  { name: 'Lisa Park', handle: 'lisap', avatar: A.lisa },
  { name: 'Anna Torres', handle: 'annat', avatar: A.anna },
  { name: 'David Kim', handle: 'davidk', avatar: A.david },
  { name: 'Chris Bennett', handle: 'chrisb', avatar: A.chris },
  { name: 'Emily Stone', handle: 'emilys', avatar: A.emily },
];

export const ytThumb = (id) => `https://img.youtube.com/vi/${id}/maxresdefault.jpg`;

export const conversations = [
  {
    id: 'c1', name: 'Sarah', avatar: A.sarah, online: true, verified: false,
    preview: 'Typing...', typing: true, expiresAt: hoursFromNow(24), locked: false, translated: false,
    messages: [
      { id: 'x1', from: 'them', text: 'Heyy! Are we still on for tomorrow?', expiresAt: hoursFromNow(23) },
      { id: 'x2', from: 'me', text: 'See you tomorrow! 👋', expiresAt: hoursFromNow(23) },
      { id: 'x3', from: 'me', text: "Can't wait! See you then!", translated: true, expiresAt: hoursFromNow(23) },
    ],
  },
  {
    id: 'c2', name: 'David', avatar: A.david, online: false, verified: true,
    preview: 'See you soon! 🧡', typing: false, expiresAt: hoursFromNow(3), locked: false, translated: false,
    messages: [
      { id: 'x1', from: 'them', text: 'On my way now.', expiresAt: hoursFromNow(3) },
      { id: 'x2', from: 'me', text: 'Perfect, driving safe!', expiresAt: hoursFromNow(3) },
      { id: 'x3', from: 'them', text: 'See you soon! 🧡', expiresAt: hoursFromNow(3) },
    ],
  },
  {
    id: 'c3', name: 'Emily', avatar: A.emily, online: true, verified: false,
    preview: '¡Hola! ¿Cómo estás?', typing: false, expiresAt: hoursFromNow(6), locked: true, translated: true,
    messages: [
      { id: 'x1', from: 'them', text: '¡Hola! ¿Cómo estás?', translated: true, expiresAt: hoursFromNow(6) },
      { id: 'x2', from: 'me', text: 'Doing great! You?', expiresAt: hoursFromNow(6) },
    ],
  },
  {
    id: 'c4', name: 'Alex', avatar: A.alex, online: false, verified: false,
    preview: 'Photo sent', typing: false, expiresAt: hoursFromNow(21), locked: true, translated: false,
    messages: [
      { id: 'x1', from: 'them', text: 'Photo sent', photo: IMG.P.mountain, expiresAt: hoursFromNow(21) },
      { id: 'x2', from: 'me', text: 'Whoa, incredible view!', expiresAt: hoursFromNow(21) },
    ],
  },
  {
    id: 'c5', name: 'Jessica', avatar: A.jessica, online: false, verified: true,
    preview: 'Call ended', typing: false, expiresAt: hoursFromNow(5), locked: true, translated: false,
    messages: [
      { id: 'x1', from: 'them', text: 'Call ended · 12m 04s', system: true, expiresAt: hoursFromNow(5) },
      { id: 'x2', from: 'me', text: 'Great catching up!', expiresAt: hoursFromNow(5) },
    ],
  },
];

export const alerts = [
  { id: 'n1', type: 'like', user: 'Sarah Collins', avatar: A.sarah, text: 'liked your moment', time: '2m', image: IMG.P.sunset, expiresAt: hoursFromNow(23) },
  { id: 'n2', type: 'follow', user: 'David Kim', avatar: A.david, text: 'started following you', time: '18m', expiresAt: hoursFromNow(22) },
  { id: 'n3', type: 'comment', user: 'Anna Torres', avatar: A.anna, text: 'commented: "Stunning! 🔥"', time: '1h', image: IMG.P.coffee, expiresAt: hoursFromNow(20) },
  { id: 'n4', type: 'mention', user: 'Michael Reed', avatar: A.michael, text: 'mentioned you in a moment', time: '3h', expiresAt: hoursFromNow(18) },
  { id: 'n5', type: 'like', user: 'Lisa Park', avatar: A.lisa, text: 'and 42 others liked your photo', time: '5h', image: IMG.P.selfie, expiresAt: hoursFromNow(12) },
  { id: 'n6', type: 'follow', user: 'Chris Bennett', avatar: A.chris, text: 'started following you', time: '7h', expiresAt: hoursFromNow(9) },
];

export const profile = {
  name: 'Sarah Collins',
  handle: '@sarahcollins',
  avatar: A.sarah,
  cover: IMG.P.beach2,
  verifiedUser: true,
  verifiedLocation: true,
  location: 'New York, USA',
  bio: [
    { icon: 'compass', text: 'Traveler' },
    { icon: 'camera', text: 'Photography lover' },
    { icon: 'sparkles', text: 'Living life to the fullest!' },
  ],
  stats: { posts: 128, followers: '2.3K', following: 310 },
  photos: [P.beach2, P.camera, P.city, P.dog, P.coffeeWide, P.mountain],
  favorites: [P.sunset, P.selfie, P.cameraWide],
  about:
    "Full-time traveler and photography enthusiast capturing fleeting moments before they fade. Every photo here disappears in 24 hours — because the best memories are the ones you were present for.",
};

export const incomingCall = { name: 'Sarah', avatar: A.sarah, expiresLabel: 'Expires in 24h' };

// ---------- Shop ----------
const sizeProd = (u) => `${u}?crop=entropy&cs=srgb&fit=crop&w=600&h=600&q=80`;
export const shopCategories = ['All', 'Fashion', 'Tech', 'Travel', 'Accessories'];
export const shopProducts = [
  { id: 'sp1', name: 'Wayfarer Sunglasses', price: 2499, cat: 'Accessories', seller: 'UrbanOptics', rating: 4.7, tag: 'Trending', image: sizeProd('https://images.unsplash.com/photo-1572635196237-14b3f281503f') },
  { id: 'sp2', name: 'Minimal White Watch', price: 5999, cat: 'Fashion', seller: 'TimeCo', rating: 4.8, image: sizeProd('https://images.unsplash.com/photo-1523275335684-37898b6baf30') },
  { id: 'sp3', name: 'Runner Sneakers', price: 4299, cat: 'Fashion', seller: 'StridePro', rating: 4.6, tag: 'Hot', image: sizeProd('https://images.unsplash.com/photo-1560769629-975ec94e6a86') },
  { id: 'sp4', name: 'Leather Backpack', price: 3799, cat: 'Travel', seller: 'RoamGoods', rating: 4.9, image: sizeProd('https://images.unsplash.com/photo-1622560480605-d83c853bc5c3') },
  { id: 'sp5', name: 'DSLR Camera', price: 48999, cat: 'Tech', seller: 'LensLab', rating: 4.9, tag: 'Trending', image: sizeProd('https://images.unsplash.com/photo-1502920917128-1aa500764cbd') },
  { id: 'sp6', name: 'Studio Headphones', price: 8999, cat: 'Tech', seller: 'AudioHaus', rating: 4.7, image: sizeProd('https://images.unsplash.com/photo-1583394838336-acd977736f90') },
  { id: 'sp7', name: 'Canvas Tote Bag', price: 1299, cat: 'Accessories', seller: 'EcoCarry', rating: 4.5, image: sizeProd('https://images.unsplash.com/photo-1574365569389-a10d488ca3fb') },
];

// ---------- Places / Location discovery ----------
export const currentPlace = { name: 'Sunset Beach Resort', area: 'Maldives', image: P.beach2 };
export const nearbyPeople = [
  { name: 'Sarah', avatar: A.sarah, distance: '20 m away', place: 'Sunset Beach Resort' },
  { name: 'Michael', avatar: A.michael, distance: '50 m away', place: 'Pool deck' },
  { name: 'Anna', avatar: A.anna, distance: '80 m away', place: 'Beach bar' },
  { name: 'David', avatar: A.david, distance: '120 m away', place: 'Lobby' },
  { name: 'Lisa', avatar: A.lisa, distance: '150 m away', place: 'Spa' },
];
export const placeTypes = ['All', 'Famous', 'Hotels', 'Restaurants', 'Food', 'B2B', 'Beaches'];

const PL = {
  landmark1: 'https://images.unsplash.com/photo-1705445214419-f10affd36c0a?crop=entropy&cs=srgb&fm=jpg&w=900&h=600&q=80',
  landmark2: 'https://images.unsplash.com/photo-1503572327579-b5c6afe5c5c5?crop=entropy&cs=srgb&fm=jpg&w=900&h=600&q=80',
  rest1: 'https://images.unsplash.com/photo-1622115837997-90c89ae689f9?crop=entropy&cs=srgb&fm=jpg&w=900&h=600&q=80',
  rest2: 'https://images.unsplash.com/photo-1551632436-cbf8dd35adfa?crop=entropy&cs=srgb&fm=jpg&w=900&h=600&q=80',
  mart1: 'https://images.unsplash.com/photo-1670684684445-a4504dca0bbc?crop=entropy&cs=srgb&fm=jpg&w=900&h=600&q=80',
  mart2: 'https://images.unsplash.com/photo-1604719312566-8912e9227c6a?crop=entropy&cs=srgb&fm=jpg&w=900&h=600&q=80',
  apt1: 'https://images.unsplash.com/photo-1515263487990-61b07816b324?crop=entropy&cs=srgb&fm=jpg&w=900&h=600&q=80',
  apt2: 'https://images.unsplash.com/photo-1628592102751-ba83b0314276?crop=entropy&cs=srgb&fm=jpg&w=900&h=600&q=80',
  wh1: 'https://images.unsplash.com/photo-1684695749267-233af13276d0?crop=entropy&cs=srgb&fm=jpg&w=900&h=600&q=80',
  wh2: 'https://images.unsplash.com/photo-1553413077-190dd305871c?crop=entropy&cs=srgb&fm=jpg&w=900&h=600&q=80',
};

export const places = [
  { id: 'pl1', type: 'hotel', name: 'Sunset Beach Resort', area: 'Maldives', image: P.beach2, rating: 4.8, price: 8500, distance: '0.2 km', friends: 3, peopleHere: [A.sarah, A.michael, A.lisa, A.anna], tags: ['Beachfront', 'Infinity Pool', 'Spa'] },
  { id: 'fm1', type: 'famous', name: 'The Grand Tower', area: 'City Center', image: PL.landmark1, rating: 4.9, distance: '1.4 km', friends: 5, peopleHere: [A.david, A.emily, A.chris], tags: ['Landmark', 'Photo Spot', 'Must Visit'] },
  { id: 'fm2', type: 'famous', name: 'Liberty Monument', area: 'Harbor', image: PL.landmark2, rating: 4.7, distance: '3.0 km', tags: ['Heritage', 'Sightseeing'] },
  { id: 'rs1', type: 'restaurant', name: 'The Gourmet Table', area: 'Downtown', image: PL.rest1, rating: 4.8, distance: '0.6 km', cuisine: 'Fine Dining · ₹₹₹', friends: 2, peopleHere: [A.anna, A.jessica], tags: ['Rooftop', 'Cocktails', 'Reservations'] },
  { id: 'rs2', type: 'restaurant', name: 'Bella Cucina', area: 'Old Town', image: PL.rest2, rating: 4.6, distance: '1.1 km', cuisine: 'Italian · ₹₹', tags: ['Pizza', 'Pasta', 'Family'] },
  { id: 'fd1', type: 'food', name: 'FreshMart Express', area: 'Sector 12', image: PL.mart1, rating: 4.5, distance: '0.4 km', deliveryTime: '12 min', tags: ['Groceries', 'Free Delivery'] },
  { id: 'fd2', type: 'food', name: 'QuickBite Store', area: 'Main Road', image: PL.mart2, rating: 4.4, distance: '0.9 km', deliveryTime: '18 min', tags: ['Snacks', 'Beverages', '24x7'] },
  { id: 'b1', type: 'b2b', name: 'MetroWholesale Hub', area: 'Industrial Area', image: PL.wh1, rating: 4.7, distance: '4.2 km', supplier: 'Verified Supplier', moq: '50 units', tags: ['Bulk', 'GST Invoice', 'Logistics'] },
  { id: 'b2', type: 'b2b', name: 'BulkSupply Depot', area: 'Trade Zone', image: PL.wh2, rating: 4.5, distance: '6.0 km', supplier: 'Manufacturer', moq: '100 units', tags: ['Wholesale', 'Export', 'Credit'] },
  { id: 'pl2', type: 'beach', name: 'Palm Cove Beach', area: 'Maldives', image: P.beach1, rating: 4.9, distance: '0.5 km', friends: 2, peopleHere: [A.david, A.alex], tags: ['Swimming', 'Sunset Views'] },
  { id: 'pl2', type: 'beach', name: 'Palm Cove Beach', area: 'Maldives', image: P.beach1, rating: 4.9, distance: '0.5 km', friends: 2, peopleHere: [A.david, A.alex], tags: ['Swimming', 'Sunset Views'] },
  { id: 'pl3', type: 'hotel', name: 'Skyline City Hotel', area: 'New York', image: P.city, rating: 4.6, price: 12000, distance: '1.1 km', friends: 1, peopleHere: [A.chris, A.emily, A.ryan], tags: ['Rooftop Bar', 'Business'] },
  { id: 'pl4', type: 'hotel', name: 'Mountain View Lodge', area: 'Aspen', image: P.mountain, rating: 4.7, price: 6900, distance: '2.3 km', friends: 1, peopleHere: [A.nina], tags: ['Scenic', 'Ski-in'] },
  { id: 'pl5', type: 'cafe', name: 'Corner Cafe', area: 'Downtown', image: P.coffee, rating: 4.5, distance: '0.3 km', friends: 2, peopleHere: [A.anna, A.jessica], tags: ['Coffee', 'Free Wifi'] },
];

export const reportReasons = [
  'Spam or misleading',
  'Harassment or bullying',
  'Nudity or sexual content',
  'Hate speech or symbols',
  'Violence or dangerous acts',
  'Scam or fraud',
  'False information',
  'Underage / child safety',
];

